import { QueryOptions } from "../../Common/useQuery";
import useUserQuery from "../../Common/useUserQuery";
import { useSelectedBusiness } from "../../UserAccess/useSelectedBusiness";

export interface EmailSettingsDto {
  orderTransactionsIsEnabled: boolean;
  orderTransactionsSendToCustomers: boolean;
  orderTransactionsSendToBranches: boolean;
  orderTransactionsSendToDrivers: boolean;
  orderTransactionsSendToCarriers: boolean;
  orderTransactionsSendToApplicators: boolean;
  connectorErrorsIsEnabled: boolean;
  connectorErrorsRecipients: string[],
  queueCount: number;
  sentCount: number;
  failedCount: number;
  successRate: number;
}

const useGetEmailSettings = (options?: QueryOptions<EmailSettingsDto>) => {
  const business = useSelectedBusiness();

  return useUserQuery<EmailSettingsDto>(
    { path: `/api/businesses/${business.id}/emailSettings` },
    options);
}

export default useGetEmailSettings;
